import React from "react";
import { declineNotification, updateNotificationPreference } from "../../endpoints/auth/played-numbers_PUT.schema";
import { trackChooseNotification } from "../../helpers/analytics";
import { ChoixExplicite } from "./ChoixExplicite";

/**
 * Choix du mail de résultat juste après l'enregistrement d'une grille (activation, D5) : deux
 * boutons de même poids, rien de coché d'avance. « Non merci » est mémorisé sur le compte
 * (décision du 23/10/2026) : la question n'est plus reposée ; le réglage reste « aucun mail »
 * et se change dans Mes grilles.
 */
export function ChoixMailResultat({ onChoisi }: { onChoisi?: (canal: "email" | "none") => void }) {
  return (
    <ChoixExplicite
      titre="Recevoir votre score par mail ?"
      texte="Chaque soir vers 21 h 30, après l'import du tirage : combien de vos numéros sont sortis. Désactivable à tout moment dans Mes grilles."
      oui="Oui, par mail"
      non="Non merci, je viendrai voir"
      onChoix={async (oui) => {
        if (oui) {
          await updateNotificationPreference({ notification: "email" });
        } else {
          // Un refus non enregistré (réseau) ne bloque pas la confirmation : la question reviendra.
          await declineNotification().catch(() => undefined);
        }
        trackChooseNotification(oui ? "email" : "refus");
        onChoisi?.(oui ? "email" : "none");
      }}
      confirmationOui="C'est noté : votre score arrive par mail après chaque tirage."
      confirmationNon="D'accord : votre score vous attend dans Mes grilles après chaque tirage."
    />
  );
}
